import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const locationStorageTypesWidget: DashboardWidgetConfiguration = {
  widgetId: "location.storage-types",
  name: "Storage by type",
  description: "Storage by type using the reusable report-widget visualization.",
  apps: [
    "configuration",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.storage-locations",
      ...period(1),
      select: [
        {
          type: "field",
          field: "location_type",
          as: "location_type",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "storage_location_id",
          as: "locations",
        },
      ],
      group_by: [
        {
          field: "location_type",
        },
      ],
      limit: 10,
    },
  },
  inputs: {
    title: "Storage by type",
    subtitle: "Live RQL report",
    output: "pie",
    visualization: "donut",
    icon: "average",
    showTimeControls: false,
  },
  dummyData: {
    value: "0 storage locations",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
